<template>
  <div class="color--ring">
    <div 
      v-for="item in list" 
      :key="item" 
      :style="[/^#/.test(item) ? {borderColor: item} : '']"
      :class="['color--ring-item', {active: current === item}, !/^#/.test(item) ? 'no-border' : '']"
      @click="clickColor(item)">
        <span v-if="/^#/.test(item)" :style="{backgroundColor: item}" class="color--ring-check"></span>
        <span v-else class="color--ring-rainbow " >
          <span class="color--ring-rainbow-inner">
            <span class="color--ring-rainbow-check"></span>
          </span>
        </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ColorRing',
  props: {
    list: Array,
  },
  data() {
    return {
      current: null,
    };
  },
  methods: {
    clickColor: function(active) {
      this.current = active;
      this.$emit('change', active);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ColorRing.vue